import {
    ACTION_VIEW_SEARCH_PAGE_ALLOWED,
    ACTION_VIEW_REPORTS_PAGE_ALLOWED,
    ACTION_VIEW_CANCEL_PAGE_ALLOWED,
    ACTION_VIEW_NOTIFICATION_PAGE_ALLOWED,
    ACTION_VIEW_BUS_CANCELLATION_PAGE_ALLOWED,
    ACTION_VIEW_STAFF_PAGE_ALLOWED,
    ACTION_VIEW_BOOKED_TICKETS_REPORT_ALLOWED,
    ACTION_VIEW_SETTLEMENT_REPORT_ALLOWED,
    ACTION_VIEW_MASTER_TRIP_REPORT_ALLOWED,
    ACTION_VIEW_PASSENGER_INFO_REPORT_ALLOWED,
    ACTION_VIEW_SALES_REPORT_ALLOWED,
    ACTION_VIEW_MASTER_AGENT_SALES_REPORT_ALLOWED,
    ACTION_VIEW_TICKET_SEARCH_REPORT_ALLOWED,
    ACTION_VIEW_TICKET_SEARCH_REPORT_OLD_ALLOWED,
    ACTION_VIEW_TRIP_REPORT_ALLOWED,
    ACTION_VIEW_BLOCKED_TICKETS_REPORT_ALLOWED,
    ACTION_VIEW_PERFORMANCE_REPORT_ALLOWED,
    ACTION_VIEW_TOTAL_TRANSACTION_REPORT_ALLOWED,
    ACTION_VIEW_WEB_TICKET_CANCELLATION_REPORT_ALLOWED,
    ACTION_TO_VIEW_TRIP_SHEET_PERMISSION_PAGE,
    ACTION_VIEW_ABANDONED_REPORT_ALLOWED,
    ACTION_VIEW_WEB_TICKET_SALES_REPORT_ALLOWED,
    TRIP_EXPENSE_PAGE,
    ACTION_SMS_REPORT_ALLOWED,
    ACTION_VIEW_TICKETS_BOOKED_AFTER_START_TIME_ALLOWED,
    ACTION_VIEW_AGENTS_PAGE_ALLOWED,
    ACTION_VIEW_AGENTS_TRANSACTION_PAGE_ALLOWED,
    ADMIN_VIEW_AGENTS_PAGE,
    ADMIN_VIEW_TRIPS_PAGE,
    ADMIN_VIEW_BULK_TRIP_VEHICLE_UPDATE_PAGE,
    ADMIN_VIEW_SCHEDULES_PAGE,
    AGENT_VIEW_STANDARD_STOPS_PAGE,
    ACTION_VIEW_ANALYTICS_DEMAND,
    VIEW_AGENT_TRIP_CREATE,
    ACTION_TO_VIEW_SERVICE_COUNT_REPORT,
    ACTION_TO_VIEW_ACTIVE_BOOKINGS_REPORT,
    PRIORITY_ROUTES_PAGE_ALLOWED,
    ACTION_VIEW_RESCHEDULED_REPORT_PAGE,
    ACTION_VIEW_TICKET_SHARING_REPORT_ALLOWED, VIEW_PREPAID_AGENT_ACCOUNT_DATA,
    ACTION_TO_VIEW_OPERATOR_COST_SUMMARY, ACTION_TO_VIEW_OPERATOR_TRANSACT_SUMMARY, ACTION_VIEW_REVENUE_REPORT_ALLOWED, ADMIN_VIEW_CITIES_PAGE,
    ACTION_TO_VIEW_MAVEN_TRANSACTION_REPORT, ACTION_TO_VIEW_OPERATOR_TRACKING_SUMMARY,
    USER_ACTION_PAGE_ALLOWED,
    SHOW_AGENT_DASHBOARD,
    SHOW_OPERATOR_CONFIG_PAGE,
    SHOW_BUS_OPERATOR_PAGE_FOR_BDM,
    SHOW_COLOUR_CONFIG_PAGE,
    SHOW_MAX_DISCOUNT,
    SHOW_MIN_AND_MAX_FARE_FOR_SERVER_DISCOUNT,
    AGENT_VIEW_OPERATOR_WEBSITES_MODIFY_ALLOWED,
    SERVICE_ACCESS_PAGE_ALLOWED,
    MANAGE_SERVICE_SHARING,
    MANAGE_BOOKING_PARTNERS,
    ACTION_VIEW_SHARED_TRIP_SALES_REPORT_ALLOWED,
    ADMIN_VIEW_VEHICLE_MANAGEMENT_PAGE,
    ADMIN_VIEW_TEMPORARY_CHANGES_PAGE,
    ADMIN_VIEW_BUS_PAGE,
    AGENT_MODIFY_CANCELLATION_POLICY,
    ACTION_VIEW_SYSTEM_INFO_PAGE,
    AGENT_VIEW_OTA_SEARCH_PAGE_ALLOWED,
    ACTION_VIEW_DRIVER_ATTENDANCE_REPORT_ALLOWED,
    ACTION_VIEW_OCCUPANCY_REPORT_ALLOWED,
    ACTION_VIEW_BUS_SERVICE_COLLECTION_REPORT_ALLOWED,
    ACTION_VIEW_EXPENSE_REPORT_ALLOWED,
    ACTION_STOP_ANALYSIS_REPORT,
    VIEW_CONFIG_EXPENSES_PAGE
    ,
    ADMIN_VIEW_METADATA_PAGE,
    VIEW_BOOKING_CONFIG,
    VIEW_BILLING_CONFIG,
    ACTION_VIEW_SETTLEMENT_ADMIN,
    ACTION_VIEW_OWN_SETTLEMENT,
    ACTION_SET_SETTLEMENT_OPENING_BALANCE,
    ACTION_GENERATE_SETTLEMENT_DRAFT,
    ACTION_EDIT_SETTLEMENT,
    ACTION_APPROVE_SETTLEMENT,
    ACTION_CANCEL_SETTLEMENT,
    ACTION_RECORD_SETTLEMENT_PAYMENT,
    ACTION_MODIFY_SETTLEMENT_PAYMENT,
    ACTION_CREATE_TRIP_FROM_EXCEL,
    dafidyUserCheck
} from './../../utils/constant';
import {
    checkActionAllowed
} from './../../utils/utilities';
import { isRechargeAgent } from './../upi-booking/upi-recharge.component';

export const viewTicketBookedAfterTripStartTime=()=>{
    if(checkActionAllowed(ACTION_VIEW_TICKETS_BOOKED_AFTER_START_TIME_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const viewSmsReport=()=>{
    if(checkActionAllowed(ACTION_SMS_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkSearchPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_SEARCH_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkDashBoardPage=()=>{
    if(checkActionAllowed(SHOW_AGENT_DASHBOARD)){
        return true;
    }else{
        return false;
    }
}


export const checkCancelPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_CANCEL_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const checkViewNotificationPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_NOTIFICATION_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const checkBusCancellationPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_BUS_CANCELLATION_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkStaffPage=()=>{
    if(dafidyUserCheck() || checkActionAllowed(ACTION_VIEW_STAFF_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkAgentsPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_AGENTS_TRANSACTION_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkAgentsTransactionPage=()=>{
    // Also visible to prepaid "agent" users of a UPI-enabled operator, for self wallet recharge.
    if(checkActionAllowed(ACTION_VIEW_AGENTS_TRANSACTION_PAGE_ALLOWED) || isRechargeAgent()){
        return true;
    }else{
        return false;
    }
}

export const checkAgentLedgerPage=()=>{
    // Agent Ledger is NOT for recharge agents - permission-based only.
    if(checkActionAllowed(ACTION_VIEW_AGENTS_TRANSACTION_PAGE_ALLOWED) && !isRechargeAgent()){
        return true;
    }else{
        return false;
    }
}

export const checkToViewSystemInfoPage=()=>{
    if(checkActionAllowed(ACTION_VIEW_SYSTEM_INFO_PAGE)){
        return true;
    }else{
        return false;
    }
}


export const viewBookedTicketsReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_BOOKED_TICKETS_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewTicketSharingReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_TICKET_SHARING_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewSettlementReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_SETTLEMENT_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const viewMasterTripReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_MASTER_TRIP_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const viewPassengerInfoReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_PASSENGER_INFO_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const viewSalesReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_SALES_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewMasterAgentSalesReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_MASTER_AGENT_SALES_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewSharedTripSalesReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_SHARED_TRIP_SALES_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewExpenseReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_EXPENSE_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}


export const viewTicketSearchReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_TICKET_SEARCH_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewTicketSearchReportOld=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_TICKET_SEARCH_REPORT_OLD_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewRescheduledTicketReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_RESCHEDULED_REPORT_PAGE)){
        return true;
    }else{
        return false;
    }
}


export const viewTotalTransactionReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_TOTAL_TRANSACTION_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewTripReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_TRIP_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const blockedSeatsReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_BLOCKED_TICKETS_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const cancelledSeatsReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_WEB_TICKET_CANCELLATION_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewPerformanceReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_PERFORMANCE_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewRevenueReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_REVENUE_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewPrePaidReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_MAVEN_TRANSACTION_REPORT)){
        return true;
    }else{
        return false;
    }
}

export const checkViewAbandonedReport=()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_ABANDONED_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkWebTicketSalesReport = ()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_WEB_TICKET_SALES_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const viewActiveBookings = ()=> {
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_ACTIVE_BOOKINGS_REPORT)){
        return true;
    }else{
        return false;
    }
}

export const checkWebTicketCancelReport = ()=>{
    if(checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_WEB_TICKET_CANCELLATION_REPORT_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewTripSheetPermissionPage = ()=>{
    if(checkActionAllowed(ACTION_TO_VIEW_TRIP_SHEET_PERMISSION_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const viewDemandDataReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_ANALYTICS_DEMAND)){
        return true;
    }else {
        return false;
    }
}

export const viewServiceCountReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_SERVICE_COUNT_REPORT)){
        return true;
    }else {
        return false;
    }
}

export const viewCostSummaryReportReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_OPERATOR_COST_SUMMARY)){
        return true;
    }else {
        return false;
    }
}

export const viewSettlementAdmin = () => {
    return checkActionAllowed(ACTION_VIEW_SETTLEMENT_ADMIN);
}

export const viewOwnSettlement = () => {
    return checkActionAllowed(ACTION_VIEW_OWN_SETTLEMENT);
}

export const checkToSetSettlementOpeningBalance = () => {
    return checkActionAllowed(ACTION_SET_SETTLEMENT_OPENING_BALANCE);
}

export const checkToGenerateSettlementDraft = () => {
    return checkActionAllowed(ACTION_GENERATE_SETTLEMENT_DRAFT);
}

export const checkToEditSettlement = () => {
    return checkActionAllowed(ACTION_EDIT_SETTLEMENT);
}

export const checkToApproveSettlement = () => {
    return checkActionAllowed(ACTION_APPROVE_SETTLEMENT);
}

export const checkToCancelSettlement = () => {
    return checkActionAllowed(ACTION_CANCEL_SETTLEMENT);
}

export const checkToRecordSettlementPayment = () => {
    return checkActionAllowed(ACTION_RECORD_SETTLEMENT_PAYMENT);
}

export const checkToModifySettlementPayment = () => {
    return checkActionAllowed(ACTION_MODIFY_SETTLEMENT_PAYMENT);
}

export const viewTransactionSummaryReportReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_OPERATOR_TRANSACT_SUMMARY)){
        return true;
    }else {
        return false;
    }
}

export const viewTrackingSummaryReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_TO_VIEW_OPERATOR_TRACKING_SUMMARY)){
        return true;
    }else {
        return false;
    }
}


export const tripExpenseReport =()=>{
    if(checkActionAllowed(TRIP_EXPENSE_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const tripCreate = () => {
    if (checkActionAllowed(VIEW_AGENT_TRIP_CREATE)){
        return true;
    }
    else {
        return false;
    }
}


export const checkToViewTripsPageOfAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_TRIPS_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewBulkTripVehicleUpdatePage = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_BULK_TRIP_VEHICLE_UPDATE_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewPopularRoutesPageAdmin = ()=>{
    if(checkActionAllowed(PRIORITY_ROUTES_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewUserActions = ()=>{
    if(checkActionAllowed(USER_ACTION_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewVechicleManagementPageAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_VEHICLE_MANAGEMENT_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewOperatorConfig = ()=>{
    if(checkActionAllowed(SHOW_OPERATOR_CONFIG_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewBusOperatorPage = ()=>{
    if(checkActionAllowed(SHOW_BUS_OPERATOR_PAGE_FOR_BDM)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewDiscountConfig = ()=>{
    if(checkActionAllowed(SHOW_MAX_DISCOUNT)||checkActionAllowed(SHOW_MIN_AND_MAX_FARE_FOR_SERVER_DISCOUNT)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewBookingConfig = ()=>{
    if(checkActionAllowed(VIEW_BOOKING_CONFIG)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewBillingConfig = ()=>{
    if(checkActionAllowed(VIEW_BILLING_CONFIG)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewColourConfig = ()=>{
    if(checkActionAllowed(SHOW_COLOUR_CONFIG_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewOperatorWebsiteConfig = () => {
    if (checkActionAllowed(AGENT_VIEW_OPERATOR_WEBSITES_MODIFY_ALLOWED)) {
        return true;
    } else {
        return false;
    }
}

export const checkToViewExpenseConfig = ()=>{
    if(checkActionAllowed(VIEW_CONFIG_EXPENSES_PAGE)){
        return true;
    }else{
        return false;
    }
}
export const checkToViewCitiesPageAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_CITIES_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewAddressBookPageAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_CITIES_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewSchedulesPageOfAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_SCHEDULES_PAGE)){
        return true;
    }else{
        return false;
    }
}


export const checkToViewStandardStopsPage = ()=>{
    if(checkActionAllowed(AGENT_VIEW_STANDARD_STOPS_PAGE)){
        return true;
    }else{
        return false;
    }
}


export const checkToViewAgentsPageOfAdmin = ()=>{
    if(checkActionAllowed(ADMIN_VIEW_AGENTS_PAGE)){
        return true;
    }else{
        return false;
    }
}

export const checkPrepaidOTAPage = ()=>{
    if(checkActionAllowed(VIEW_PREPAID_AGENT_ACCOUNT_DATA)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewServiceAccessPage = ()=>{
    if(checkActionAllowed(SERVICE_ACCESS_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewServiceSharingPage = ()=>{
    if(checkActionAllowed(MANAGE_SERVICE_SHARING)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewBookingPartnersPage = ()=>{
    if(checkActionAllowed(MANAGE_BOOKING_PARTNERS)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewTemporaryChangesPage = () => {
    if(checkActionAllowed(ADMIN_VIEW_TEMPORARY_CHANGES_PAGE)){
        return true;
    } else {
        return false;
    }
}

export const checkToViewBusesPageAdmin = () => {
    if(checkActionAllowed(ADMIN_VIEW_BUS_PAGE)){
        return true;
    }else{
        return false;
    }
};

export const checkToViewCancellationPolicyPage = () => {
    if(checkActionAllowed(AGENT_MODIFY_CANCELLATION_POLICY)){
        return true;
    }else{
        return false;
    }
};

export const checkToViewOtaSearchPage = () => {
    if(checkActionAllowed(AGENT_VIEW_OTA_SEARCH_PAGE_ALLOWED)){
        return true;
    }else{
        return false;
    }
}

export const checkToViewMetaDataPage = () => {
    return checkActionAllowed(ADMIN_VIEW_METADATA_PAGE);
}

export const viewDriverAttendanceReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_DRIVER_ATTENDANCE_REPORT_ALLOWED)){
        return true;
    }else {
        return false;
    }
}

export const viewStopAnalysisReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_STOP_ANALYSIS_REPORT)){
        return true;
    }else {
        return false;
    }
}

export const checkRevenueReport = () => {
    return viewTotalTransactionReport()||
    viewPerformanceReport()||
    viewSettlementReport()||
    viewCostSummaryReportReport()||
    viewTransactionSummaryReportReport()||
    viewRevenueReport()||
    viewPrePaidReport()||
    checkViewAbandonedReport()||
    viewBusServiceCollectionReport();
}

export const viewBusServiceCollectionReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_BUS_SERVICE_COLLECTION_REPORT_ALLOWED)){
        return true;
    }else {
        return false;
    }
}

export const viewOccupancyReport = () => {
    if (checkActionAllowed(ACTION_VIEW_REPORTS_PAGE_ALLOWED)&&checkActionAllowed(ACTION_VIEW_OCCUPANCY_REPORT_ALLOWED)){
        return true;
    }else {
        return false;
    }
}

export const checkOtherReport = () => {
    return cancelledSeatsReport()||
    blockedSeatsReport()||
    viewPassengerInfoReport()||
    viewTicketSearchReportOld()||
    viewRescheduledTicketReport()||
    viewSmsReport()||
    viewTicketBookedAfterTripStartTime()||
    viewDemandDataReport()||
    viewServiceCountReport()||
    viewOccupancyReport()||
    viewTrackingSummaryReport()||
    viewTicketSharingReport()||
    viewExpenseReport()||
    viewDriverAttendanceReport()
  }

export const checkToViewTicketImportPage = () => {
    if (checkActionAllowed(ACTION_CREATE_TRIP_FROM_EXCEL)) {
        return true;
    }
    return false;
}